import { Reveal } from "@/components/Reveal";
import { CheckCircle2 } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";

export const About = () => {
  const settings = useSettings();
  const points = [
    "Renovaties van A tot Z begeleid",
    "Duidelijke communicatie en planning",
    "Uitsluitend werk waar we trots op zijn",
  ];
  return (
    <section
      id="over-ons"
      data-testid="about-section"
      className="py-24 md:py-32 bg-[#050505]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        <Reveal>
          <span className="text-[#FF1A1A] text-sm font-semibold tracking-[0.25em] uppercase">
            Over ons
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-white mt-5 leading-tight">
            {settings.about_heading}
          </h2>
          <p className="text-base md:text-lg text-white/65 font-light leading-relaxed mt-7">
            {settings.about_text}
          </p>
          <div className="mt-8 flex flex-col gap-4">
            {points.map((p) => (
              <div key={p} className="flex items-center gap-3">
                <CheckCircle2 className="text-[#FF1A1A] shrink-0" size={22} strokeWidth={1.5} />
                <span className="text-white/80">{p}</span>
              </div>
            ))}
          </div>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="relative">
            <div className="absolute -top-5 -left-5 w-24 h-24 border-t-2 border-l-2 border-[#FF1A1A] hidden md:block" />
            <img
              src={settings.about_image}
              alt="Klusbedrijf Pruijn vakmanschap"
              className="w-full h-[420px] md:h-[560px] object-cover"
              data-testid="about-image"
            />
            <div className="absolute -bottom-5 -right-5 w-24 h-24 border-b-2 border-r-2 border-[#FF1A1A] hidden md:block" />
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default About;
